import { render, staticRenderFns } from "./inputItem.vue?vue&type=template&id=8d8779a8&scoped=true"
import script from "./inputItem.vue?vue&type=script&lang=js"
export * from "./inputItem.vue?vue&type=script&lang=js"
import style0 from "./inputItem.vue?vue&type=style&index=0&id=8d8779a8&lang=scss&scoped=true"
import style1 from "./inputItem.vue?vue&type=style&index=1&id=8d8779a8&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8d8779a8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\work\\git-new\\ai-business-web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8d8779a8')) {
      api.createRecord('8d8779a8', component.options)
    } else {
      api.reload('8d8779a8', component.options)
    }
    module.hot.accept("./inputItem.vue?vue&type=template&id=8d8779a8&scoped=true", function () {
      api.rerender('8d8779a8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/clue/advancecomponets/children/inputItem.vue"
export default component.exports